import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import { BibliographyFullIdWithMarcNo } from '@/types'

export interface ModalBibliographySearchResultInterface {
  isSelect?: boolean
  onBackCondition?: () => void
  onBackResult?: () => void
  onTitle?: (bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) => void
  onSelect?: (
    bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
  ) => void
  // TODO 次期バージョンの実装の為コメントアウト
  // onMultiReserve?: (bibliographyFullIds: BibliographyFullId[]) => void
  // onGroupReserve?: (bibliographyFullIds: BibliographyFullId[]) => void
}

@Module({
  name: 'ModalBibliographySearchResultStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographySearchResultStore extends BaseStore {
  _isOpen: boolean = false

  _isSelect: boolean = false

  _backConditionCallback?: () => void

  _backResultCallback?: () => void

  _titleCallback?: (
    bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo
  ) => void

  _selectCallback?: (
    bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
  ) => void

  // TODO 次期バージョンの実装の為コメントアウト
  // _multiReserveCallback?: (bibliographyFullIds: BibliographyFullId[]) => void
  //
  // _groupReserveCallback?: (bibliographyFullIds: BibliographyFullId[]) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get isSelect(): boolean {
    return this._isSelect
  }

  @Mutation
  public open(params?: ModalBibliographySearchResultInterface) {
    this._isOpen = true
    if (params) {
      this._isSelect = params.isSelect ?? false
      this._backConditionCallback = params.onBackCondition
      this._backResultCallback = params.onBackResult
      this._titleCallback = params.onTitle
      this._selectCallback = params.onSelect
      // TODO 次期バージョンの実装の為コメントアウト
      // this._multiReserveCallback = params.onMultiReserve
      // this._groupReserveCallback = params.onGroupReserve
    }
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public backCondition() {
    if (this._backConditionCallback) {
      this._backConditionCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public backResult() {
    if (this._backResultCallback) {
      this._backResultCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public title(bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) {
    if (this._titleCallback) {
      this._titleCallback(bibliographyFullIdWithMarcNo)
    }

    this._isOpen = false
  }

  @Mutation
  public select(bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]) {
    if (this._selectCallback) {
      this._selectCallback(bibliographyFullIdsWithMarcNo)
    }

    // 選択後、エラーが発生した場合、ダイアログ表示を閉じたくないのでこの時点ではfalseを設定しない
  }

  // TODO 次期バージョンの実装の為コメントアウト
  // @Mutation
  // public multiReserve(bibliographyFullIds: BibliographyFullId[]) {
  //   if (this._multiReserveCallback) {
  //     this._multiReserveCallback(bibliographyFullIds)
  //   }
  //
  //   this._isOpen = false
  // }

  // TODO 次期バージョンの実装の為コメントアウト
  // @Mutation
  // public groupReserve(bibliographyFullIds: BibliographyFullId[]) {
  //   if (this._groupReserveCallback) {
  //     this._groupReserveCallback(bibliographyFullIds)
  //   }
  //
  //   this._isOpen = false
  // }
}
